module.exports = __webpack_public_path__ + "img/security.d5ac5563.svg";